// src/utils/textBracketSanitize.ts
export const cleanTextForTTS = (text: string | undefined): string => {
  if (!text) {
    return '';
  }

  return text.replace(/\s*\(.*?\)\s*/g, ' ').trim();
};
